import { useAppKit } from '@reown/appkit/react';
import { useAccount, useBalance } from 'wagmi';
import { formatUnits } from 'viem';

// Components
import ArrowIcon from './ArrowIcon';

// Styles
import styles from './WalletController.module.scss';

const NETWORKS_ICONS = {
  42161: './images/arbitrum.webp',
  10: './images/optimism.webp',
};

const WalletController = () => {
  const { open } = useAppKit();
  const account = useAccount();
  const { data: balanceData } = useBalance({
    address: account?.address,
  });

  const shortAddress = addr => `${addr.slice(0, 7)}..${addr.slice(-3)}`;

  if (!account) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.wallet} onClick={() => open()}>
        {account.connector?.icon && (
          <img className={styles.walletImage} src={account.connector.icon} />
        )}
        <div className={styles.walletData}>
          {account.address && (
            <p className={styles.walletAddress}>{shortAddress(account.address)}</p>
          )}
          <p className={styles.walletCount}>{formatUnits(balanceData?.value || 0, 18)} ArB-ETH</p>
        </div>
      </div>
      <div className={styles.networkWrapper} onClick={() => open({ view: 'Networks' })}>
        {NETWORKS_ICONS[account.chainId] && (
          <img
            alt="network"
            src={NETWORKS_ICONS[account.chainId]}
            className={styles.networkImage}
          />
        )}
        <p className={styles.networkName}>{account.chain?.name}</p>
        <ArrowIcon />
      </div>
    </div>
  );
};

export default WalletController;
